import { lighten } from 'polished';
import pallette from './pallette';

type NavigationTheme = {
    colors: {
        link: {
            text: string;
            hover: { text: string };
        };
        tabs: {
            text: string;
            background: string;
        };
    };
};

const { white, lightBlue, midGreen } = pallette;

const navigation: NavigationTheme = {
    colors: {
        link: {
            text: midGreen,
            hover: {
                text: lighten(0.1, midGreen),
            },
        },
        tabs: {
            text: white,
            background: lightBlue,
        },
    },
};

export default navigation;
